module.exports = __webpack_public_path__ + "static/img/CoHeadlineCorp-Regular.5da3ab7.svg";